import { NgModule } from '@angular/core';

import SettingsActions from './actions';
import SettingsStateStorageService from './services/settings-state-storage.service';

@NgModule({
    providers: [SettingsStateStorageService],
})
export default class BetslipSettingsModule {
    static readonly SettingsActions = SettingsActions;
}
